var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import * as React from 'react';
import { Grid } from '@mui/material';
import { styled } from '../styled';
import { Panel } from './panel';
var panelsLayoutComponentName = 'QuantumPanelsLayout';
var RightPanel = styled(Panel, { name: panelsLayoutComponentName, slot: 'RightPanel' })({
    width: '320px', // fixed width base on design requirements
});
var LeftPanel = styled(Panel, { name: panelsLayoutComponentName, slot: 'LeftPanel' })({
    width: '265px', // fixed width base on design requirements
});
var Root = styled(Grid, { name: panelsLayoutComponentName, slot: 'Root' })({
    display: 'flex',
    height: '100%',
});
export var PanelLayout = React.forwardRef(function (props, ref) {
    var startPanel = props.startPanel, endPanel = props.endPanel, children = props.children, rootProps = __rest(props, ["startPanel", "endPanel", "children"]);
    return (React.createElement(Root, __assign({ ref: ref }, rootProps),
        !!startPanel && React.createElement(LeftPanel, { position: "start" }, startPanel),
        React.createElement(Grid, { item: true, xs: true }, children),
        !!endPanel && React.createElement(RightPanel, { position: "end" }, endPanel)));
});
